import React from 'react';
import Hero from '../components/Hero';
import WhyCNTerminal from '../components/WhyCNTerminal';
import ServiceHighlight from '../components/ServiceHighlight';
import Services from '../components/Services';
import About from '../components/About';
import Stats from '../components/Stats';
import Contact from '../components/Contact';

const HomePage: React.FC = () => {
  return (
    <>
      <Hero />
      <About />
      <ServiceHighlight />
      <Services />
      <WhyCNTerminal />
      <Stats />
      <Contact />
    </>
  );
};

export default HomePage;

